import { useInfiniteQuery } from '@northladder/services';

import { INotificationHistoryParam } from '../types';
import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track Notification history data or cached RQ data.
 */
export const FETCH_NOTIFICATION_HISTORY_QUERY =
  'fetch-notification-history-query-key';

/**
 * This performs a get request and retrieves the notification history list.
 * Provides data fetching states to be used in the notification screen.
 */
export const useNotificationHistoryListQuery = ({
  count,
  lastDocumentId,
  readStatus,
  screen,
}: INotificationHistoryParam) => {
  const queryParams = {
    count,
    ...(lastDocumentId ? { lastDocumentId } : {}),
    ...(readStatus ? { readStatus } : {}),
    ...(screen ? { screen } : {}),
  };

  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [FETCH_NOTIFICATION_HISTORY_QUERY, count, readStatus, screen],
    retry: false,
    initialPageParam: 1,
    queryFn: () => USER_ACCOUNTS_API.fetchNotificationHistoryList(queryParams),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;

      return lastPage.history.length !== 0 ? nextPage : undefined;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  };
};
